// b('texto en español', 'english text') -> texto bilingüe
export const b = (es, en) => ({ es, en })

export const contactStep = {
  type: 'contact',
  text: b('¿Cómo te contactamos?', 'How can we reach you?'),
  hint: b('Un especialista revisará tus respuestas y te escribirá.', 'A specialist will review your answers and get back to you.'),
  icon: 'chat',
  next: null,
}
